import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { Button, Card, Input, Modal, SearchInput } from '../../Components/ui';

// Studentlar sahifasining qidiruv/filtr paneli va sana modali — ikkala tab'da bir xil ko'rinish.
// Faqat ko'rinish: holat va handler'lar tab komponentida.

export function StudentsFilterBar({ search, onSearchChange, courseFilter, hasDateFilter, onToggleFilter }) {
  return (
    <Card padding="sm">
      <div className="ui-students__filters">
        <SearchInput
          onChange={onSearchChange}
          placeholder="Qidirish..."
          value={search}
          wrapperClassName="ui-students__search"
        />
        {courseFilter}
        <Button
          variant="secondary"
          leftIcon={<SlidersHorizontal />}
          className="ui-students__filter-btn"
          onClick={onToggleFilter}
        >
          Filtrlar
          {hasDateFilter && (
            <span className="ui-students__filter-dot" role="img" aria-label="Sana filtri faol" />
          )}
        </Button>
      </div>
    </Card>
  );
}

export function StudentsDateModal({ open, onClose, fromDate, toDate, onFromChange, onToChange, onClear, onApply }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Sana bo'yicha filtr"
      size="sm"
      footer={
        <>
          <Button variant="ghost" onClick={onClear} className="ui-students__clear">
            Tozalash
          </Button>
          <Button variant="secondary" onClick={onClose}>
            Bekor qilish
          </Button>
          <Button onClick={onApply}>
            Qo'llash
          </Button>
        </>
      }
    >
      <div className="ui-students__dates">
        <Input label="Dan" type="date" value={fromDate} onChange={onFromChange} />
        <Input label="Gacha" type="date" value={toDate} onChange={onToChange} />
      </div>
    </Modal>
  );
}
